import React, {useState, useEffect} from 'react';

import { Select, notification } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

const langContext = 'components.waste-type-select';

export default (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(()=> {
        setLoading(true);
        _service({
            url: "/waste/type/list",
            success: (response) => {
                setLoading(false);
                setData(response.json);
            },
            fail: (e) => {
                notification["error"]({
                    message: intl.formatMessage({id: `${langContext}.error.message`}),
                    description: e.response.json.error,
                });
            }
        });
    }, []);

    const intl = useIntl();

    return (
        <Select placeholder={intl.formatMessage({id: `${langContext}.placeholder`})} loading={loading} {...props}>
          {
              data.map((item, key) => (
                  <Select.Option key={key} value={item.uid}>{item.code} - {item.description[intl.locale.split('-')[0]]}</Select.Option>
              ))
          }
        </Select>
    );
};

